import axios from 'axios'
import { LOUNGE_BOARD_SERVICE_TYPE } from '../features/loungeBoard/loungeBoardContants'
import { identity } from 'lodash'

const loungeBoardAxios = axios.create({
  baseURL: process.env.REACT_APP_LOUNGE_BOARD_HOST,
  withCredentials: true,
})
loungeBoardAxios.interceptors.request.use(
  config => {
    if (config.method.toLowerCase() === 'get') {
      if (config.params) {
        config.params.serviceType = LOUNGE_BOARD_SERVICE_TYPE
      } else {
        config.params = {
          serviceType: LOUNGE_BOARD_SERVICE_TYPE,
        }
      }
    }
    return config
  },
  error => Promise.reject(error)
)
loungeBoardAxios.interceptors.response.use(identity, error =>
  Promise.reject(error)
)
export default loungeBoardAxios
